import { isArray } from 'lodash';
import { serializePerson } from './person';
import { serializeOrder } from './orders';
import { serializeMail } from './mail';
import { serializeSearchMessage } from './message';

export const serializeSearchPersons = ({ persons, meta }) => {
  if (!isArray(persons) && persons.length < 1) return null;

  return {
    persons: persons.map(pr => ({
      ...serializePerson(pr),
      clientId: pr.id.toString(),
      disabled: !pr.id,
    })),
    meta,
  };
};

export const serializeSearchOrders = ({ orders, meta }) => {
  if (!isArray(orders) && orders.length < 1) return null;

  return {
    orders: orders.map(or => ({
      ...serializeOrder(or),
      orderId: or.id.toString(),
      disabled: !or.client_id,
    })),
    meta,
  };
};

export const serializeSearchMails = ({ mails, meta }) => {
  if (!isArray(mails) && mails.length < 1) return null;

  return {
    mails: mails.map(mail => ({
      ...serializeMail(mail),
      disabled: !(mail.ticket_id && mail.chain_id),
    })),
    meta,
  };
};

export const serializeSearchNotes = ({ ticket_logs: ticketLogs, meta }) => ({
  notes: ticketLogs.map(note => ({
    id: note.ticket_id.toString(),
    ticketId: note.ticket_id,
    disabled: !note.ticket_id,
    isIncoming: false,
    message: note.value_text,
    subject: 'Заметка в тикете',
    time: note.created_at,
    type: 'note',
  })),
  meta,
});

export const serializeSearchMessages = ({ messages, meta }) => {
  if (!isArray(messages) && messages.length < 1) return null;

  return {
    messages: messages.map(message => ({
      ...serializeSearchMessage(message),
      disabled: !(message.ticket_id && message.chain_id),
    })),
    meta,
  };
};
